export const ReligionConstant: { [key: number]: string } = {
  0: "해당없음",
  1: "종교 (十)",
  2: "종교 (卍)",
  3: "종교 (十, 卍)",
};

export const SearchOptionConstant: { [key: number]: string } = {
  1: "안치방법이 다양한",
  2: "고품격 추모공간을 가진",
  3: "가족과 함께하기 좋은",
  4: "가족 단위 안치가 가능한",
  5: "불교식 추모가 가능한",
  6: "기독교식 추모가 가능한",
  7: "천주교식 추모가 가능한",
};

export const BurialPlotNameNum = {
  1: "봉안",
  2: "자연",
  3: "매장",
};

export const BurialPlotTypeNameNum = {
  1: "봉안묘",
  2: "평장묘",
  3: "봉안당",
  4: "봉안담",
  5: "봉안탑",
  6: "수목장",
  7: "잔디장",
  8: "해양장",
  9: "매장묘",
};

export const BurialPlotList = [
  {
    nameNum: 1,
    name: "봉안",
    chlid: [
      {
        nameNum: 1,
        name: "봉안묘",
      },
      {
        nameNum: 2,
        name: "평장묘",
      },
      {
        nameNum: 3,
        name: "봉안당",
      },
      {
        nameNum: 4,
        name: "봉안담",
      },
      {
        nameNum: 5,
        name: "봉안탑",
      },
    ],
  },
  {
    nameNum: 2,
    name: "자연",
    chlid: [
      {
        nameNum: 6,
        name: "수목장",
      },
      {
        nameNum: 7,
        name: "잔디장",
      },
      {
        nameNum: 8,
        name: "해양장",
      },
    ],
  },
  {
    nameNum: 3,
    name: "매장",
    chlid: [
      {
        nameNum: 9,
        name: "매장묘",
      },
    ],
  },
];

export const RegionsNameNum: { [key: number]: string } = {
  1: "서울특별시",
  2: "경기남부",
  3: "경기북부",
  4: "강원도",
  5: "경상남도",
  6: "경상북도",
  7: "광주광역시",
  8: "대구광역시",
  9: "세종특별자치시",
  10: "울산광역시",
  11: "인천광역시",
  12: "전라남도",
  13: "전라북도",
  14: "제주특별자치도",
  15: "충청남도",
  16: "충청북도",
};
